const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
/* Nelia : 1 bracelet offert maximum par commande */
document.addEventListener('DOMContentLoaded', function () {
  var GIFT_PRODUCT_ID = 16118300115278;
  var busy = false;
  function limitGift() {
    if (busy) return;
    busy = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = cart.items.filter(function (i) { return i.product_id === GIFT_PRODUCT_ID; });
        var total = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
        if (total <= 1) return;
        var updates = {};
        lines.forEach(function (l, idx) { updates[l.key] = idx === 0 ? 1 : 0; });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { window.location.reload(); });
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }
  limitGift();
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, limitGift);
});